import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import { ConverterStatusEnum } from '@zaoblako/shared/modules/pacs/enums/converter-status.enum';
import type { EnumI18nInterface } from '@zaoblako/shared/common/interfaces/enum.i18n.interface';

/** Localized human-readable string representations of {@link ConverterStatusEnum} enumeration values */
export const ConverterStatusEnumI18n: EnumI18nInterface<ConverterStatusEnum> = {
  [I18nLocalesEnum.RU_RU]: {
    [ConverterStatusEnum.NOT_CONNECTED]: 'Не подключен',
    [ConverterStatusEnum.ONLINE]: 'В сети',
    [ConverterStatusEnum.OFFLINE]: 'Не в сети',
  },
  [I18nLocalesEnum.EN_US]: {
    [ConverterStatusEnum.NOT_CONNECTED]: 'Not connected',
    [ConverterStatusEnum.ONLINE]: 'Online',
    [ConverterStatusEnum.OFFLINE]: 'Offline',
  },
};
